import { Card as BaseCard } from './card';
import { Actions } from './card-actions/actions.tsx';
import { Content } from './card-content/content.tsx';
import { Footer, FooterContent } from './card-footer/footer.tsx';
import { Header } from './card-header/header.tsx';
import { Media } from './card-media/card-media.tsx';
import { Title } from './card-title';

export type { CardProps } from './card';
export type { CardFooterProps } from './card-footer';

export const Card = Object.assign(BaseCard, {
  Header,
  Title,
  Content,
  Footer,
  Media,
  FooterContent,
  Actions
});